export default class TagGroup {
    constructor(data){
        data = data || {}
        this.id = data.id || undefined;
        this.name = data.name || undefined;
        this.type = data.type || undefined;
        this.code = data.code || undefined;
    }
}